<template>
  <el-container  style="display: block;">

    <el-row  class="tui-el"  style="margin-top: 20px;margin-left: 3%;">

        <el-row :span="2" style="margin-top: 30px;">
            <el-input v-model="seachName" style="width: 150px;" placeholder="请输入名称"></el-input>

            <el-button type="primary" style="background-color: #409eff;" @click="loadList()" round>搜索</el-button>
        </el-row>
        <el-row :span="2" style="margin-top: 30px;">
            <div>
              <canvas ref="qrcodeCanvas"></canvas>
            </div>

        </el-row>
        <el-row  class="elementsz" style="margin-top: 30px;">
          <template>
            <el-table
          	:data="list"
            height="1000"
          	border
          	style="width: 95%;margin-left: 0;height: 800px;text-align: center;">
            <el-table-column

              width="600"
              label="APK名称"
               >
               <template slot-scope="scope">
                   <div>{{scope.row.name}}</div>

               </template>
            </el-table-column>
            <el-table-column

              width="300"
              label="备注"
               >
               <template slot-scope="scope">
                   <div @click="change(scope.row.content,scope.row.id)">{{scope.row.content}}</div>

               </template>
            </el-table-column>


            <el-table-column

              width="900"
              label="无密码操作"
               >
               <template slot-scope="scope">
                 <el-row>
                   <el-col :span="8" style="text-align: center;margin-top: 15px;" @click.native="downLoad(scope.row.name)">复制链接</el-col>

                   <el-col :span="8" style="text-align: center;margin-top: 15px;" @click.native="madeCode(scope.row.name)">生成二维码</el-col>

                 </el-row>
               </template>
            </el-table-column>
            <el-table-column

              width="900"
              label="密码操作"
               >
               <template slot-scope="scope">
                 <el-row>

                   <el-col :span="8" style="text-align: center;margin-top: 15px;" @click.native="downLoadPass(scope.row.id)">生成密码链接数据</el-col>
                   <!-- <el-col :span="8" style="text-align: center;margin-top: 15px;" @click.native="madeCode(scope.row.name)">生成二维码</el-col> -->

                 </el-row>
               </template>
            </el-table-column>

            </el-table>
          </template>
          <div class="page">
          	<el-pagination
          	  @size-change="loadList()"
          	  @current-change="loadList()"
          	  :current-page.sync="page"
          	  :page-size="15"
          	  background
          	  layout="total,prev, pager, next, jumper"
          	  :total="count">
          	</el-pagination>
          </div>
        </el-row>






    </el-row>
    <el-dialog
      title="修改"
      :visible.sync="disDialogVisible"
      width="30%"
      center>
      <input type="text" class="searchT" v-model="names"/>
      <span slot="footer" class="dialog-footer">
    	<el-button @click="disDialogVisible = false">取 消</el-button>
    	<el-button type="primary" @click="doChangeName()">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="密码数据修改"
      :visible.sync="disDialogVisibled"
      width="30%"
      center>
      <input type="text" class="searchT" v-model="named"/>
      <span slot="footer" class="dialog-footer">
    	<el-button @click="disDialogVisibled = false">取 消</el-button>
    	<el-button type="primary" @click="dochangePass()">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="密码数据展示"
      :visible.sync="disDialogVisibles"
      width="50%"
      center>
      <div>
        <el-row>
           <el-col :span="4" style="text-align: center;margin-top: 15px;">名称</el-col>
           <el-col :span="16" style="text-align: center;margin-top: 15px;">{{passData.name}}</el-col>
        </el-row>
        <el-row>
          <el-col :span="4" style="text-align: center;margin-top: 15px;">链接</el-col>
          <el-col :span="16" style="text-align: center;margin-top: 15px;">{{passData.url}}</el-col>
          <el-col :span="4" style="text-align: center;margin-top: 15px;" @click.native="passCode(passData.url)">生成二维码</el-col>
       </el-row>
        <el-row>
           <el-col :span="4" style="text-align: center;margin-top: 15px;">备注</el-col>
           <el-col :span="16" style="text-align: center;margin-top: 15px;">{{passData.content}}</el-col>
           <el-col :span="4" style="text-align: center;margin-top: 15px;" @click.native="changePass(passData.id,1)">修改</el-col>
        </el-row>
        <el-row>
           <el-col :span="4" style="text-align: center;margin-top: 15px;">密码</el-col>
           <el-col :span="16" style="text-align: center;margin-top: 15px;">{{passData.pass}}</el-col>
           <el-col :span="4" style="text-align: center;margin-top: 15px;" @click.native="changePass(passData.id,3)">修改</el-col>
        </el-row>
        <el-row>
           <el-col :span="4" style="text-align: center;margin-top: 15px;">过期时间</el-col>
           <el-col :span="16" style="text-align: center;margin-top: 15px;">{{passData.overtime}}</el-col>
           <el-col :span="4" style="text-align: center;margin-top: 15px;" @click.native="changePass(passData.id,2)">修改</el-col>
        </el-row>
        <el-row>
           <div style="text-align: center;">
             <canvas ref="qrcodeCanvas1"></canvas>
           </div>
        </el-row>
      </div>
      <span slot="footer" class="dialog-footer">
    	<el-button @click="disDialogVisibles = false">取 消</el-button>
    	<el-button type="primary" @click="doFalse()">确 定</el-button>
      </span>
    </el-dialog>
  </el-container>
</template>
<script type="text/javascript" src="https://gosspublic.alicdn.com/aliyun-oss-sdk-6.18.0.min.js"></script>



<script>
  import './aliyun-oss-sdk-6.18.0.min.js'
  import QRCode from 'qrcode'
  import CryptoJS from 'crypto-js';
  export default {
    props: {
        link: {
          type: String,
          required: true
        }
      },
    mounted() {
      this.generateQRCode(this.link)
    },
    data() {
       return {

         page:1,
         count:0,
         list:[],
         name:'',
         names:'',
         disDialogVisible:false,
         disDialogVisibles:false,
         seachName:'',
         passData:{'url':'','content':'','pass':'','overtime':'','id':'','name':''},
         named:'',
         disDialogVisibled:false,
         passId:0,
         passt:0,
         id:0


      }
    },
  directives: {
    },
    created() {

      this.loadList();
      // this.getUrl()
    },

  methods:{
    change(name,id){
      this.names = name
      this.id = id
      this.disDialogVisible = true
    },
    doChangeName(){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'get',
      	params:{
          id:this.id,
          n:this.names
      	},
      	url:'http://ossp.yoooooo.com/index.php/index/data/changes'
      })
      .then(res=>{

        this.disDialogVisible = false

        this.id = 0
        this.names = ''
        this.msg('修改成功','success')

        this.loadList();
      })
      .catch(err=>{

      });
    },
    passCode(link){
      QRCode.toCanvas(this.$refs.qrcodeCanvas1, link, error => {
        if (error) console.error(error)
      })
    },
    changePass(id,t){
      this.passId = id
      this.passt = t
      this.disDialogVisibled = true
    },
    dochangePass(){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'get',
      	params:{
          id:this.passId,
          t:this.passt,
          n:this.named
      	},
      	url:'http://ossp.yoooooo.com/index.php/index/data/changePass'
      })
      .then(res=>{
        this.passData = res.data.data
        this.disDialogVisibled = false
        this.passId = 0
        this.passt = 0
        this.named = ''
      })
      .catch(err=>{

      });
    },
    setUrl(id,ids){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'get',
      	params:{
          id:id,
          ids:ids
      	},
      	url:'http://ossp.yoooooo.com/index.php/index/data/setUrl'
      })
      .then(res=>{
        this.passData = res.data.data
        this.disDialogVisibles = true
      })
      .catch(err=>{

      });
    },
    downLoadPass(id){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'get',
      	params:{
          id:id
      	},
      	url:'http://ossp.yoooooo.com/index.php/index/data/passData'
      })
      .then(res=>{
        const did = res.data.data
        const dids = this.encryptData(did)
        this.setUrl(did,dids)
      })
      .catch(err=>{

      });
    },
    doFalse(){
      this.disDialogVisibles = false
    },
    encryptData(data) {
      const secretKey = 'uoag2m67hyhk458ascasg'; // 替换为你的密钥
      return CryptoJS.AES.encrypt(JSON.stringify(data), secretKey).toString();
    },
    generateQRCode(link) {
          QRCode.toCanvas(this.$refs.qrcodeCanvas, link, error => {
            if (error) console.error(error)
          })
    },
    getUrl(accessKeyId,accessKeySecret,stsToken,name){

      const client = new OSS({
              // yourRegion填写Bucket所在地域。以华东1（杭州）为例，Region填写为oss-cn-hangzhou。
        region: "oss-cn-shenzhen",
        accessKeyId: accessKeyId,
        accessKeySecret: accessKeySecret,
        stsToken: stsToken,
        bucket: "yuzhouzhimi-test",
      });

            // 配置响应头实现通过URL访问时自动下载文件，并设置下载后的文件名。
      const filename = name;
      const response = {
        "content-disposition": `attachment; filename=${encodeURIComponent(
          filename
        )}`,
      };
            // 填写Object完整路径。Object完整路径中不能包含Bucket名称。
      const url = client.signatureUrl(filename, { response });
      const urls = url.replace('yuzhouzhimi-test.oss-cn-shenzhen.aliyuncs.com','bucket.yoooooo.com')
      return urls
      //本页下载代码
      // const link = document.createElement('a');
      // link.href = urls;
      // link.download = filename;
      // link.style.display = 'none';
      // document.body.appendChild(link);
      // link.click();
      // document.body.removeChild(link);

    },
    madeCode(filename){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'get',
      	params:{

      	},
      	url:'http://ossp.yoooooo.com/index.php/index/data/ossTest'
      })
      .then(res=>{
        const cc = res.data.data
        console.log(cc);
        const urls = this.getUrl(cc.AccessKeyId,cc.AccessKeySecret,cc.SecurityToken,filename)
        this.generateQRCode(urls)

      })
      .catch(err=>{

      });
    },
    downLoad(filename){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'get',
      	params:{

      	},
      	url:'http://ossp.yoooooo.com/index.php/index/data/ossTest'
      })
      .then(res=>{
        const cc = res.data.data
        // console.log(cc);
        const urls = this.getUrl(cc.AccessKeyId,cc.AccessKeySecret,cc.SecurityToken,filename)
        this.$copyText(urls).then(
          e => {
            this.msg('链接复制成功','success')
          },
          e => {
            this.msg('链接复制失败','error')
          }
        )
        // try {
        //   navigator.clipboard.writeText(urls);
        //   this.msg('链接复制成功','success')

        // } catch (err) {
        //   this.msg('链接复制失败','error')
        // }


      })
      .catch(err=>{

      });
    },

    loadList(){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'get',
      	params:{
          name:this.seachName,
          p:this.page,

      	},
      	url:'http://ossp.yoooooo.com/index.php/index/data/getList'
      })
      .then(res=>{

        this.list = res.data.data;



      })
      .catch(err=>{

      });
    },





    msg(msg,type){
    	this.$message({
    	  message: msg,
    	  type: type
    	});
    },

  }


  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/main/list.vue